// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".side_content[data-v-41cdea66]{font-size:.83333vw!important}", ""]);
// Exports
module.exports = exports;
